import { render } from "./LayoutsPanel.vue?vue&type=template&id=295bc986&scoped=true&ts=true&lang=pug"
import script from "./LayoutsPanel.vue?vue&type=script&lang=ts"
export * from "./LayoutsPanel.vue?vue&type=script&lang=ts"

import "./LayoutsPanel.vue?vue&type=style&index=0&id=295bc986&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-295bc986"]])

export default __exports__